'use strict';

bbw.service.ServerTimeSvc = Class({

    _adjustment: undefined,

    $inject: ['serverTimestamp'],

    construct: function(serverTimestamp) {
        var serverTs = parseInt(serverTimestamp);
        if (!isNaN(serverTs)) {
            this.adjust(serverTs, (bbw && bbw.startedAt && Math.floor(+bbw.startedAt / 1000)));
        } else {
            this._adjustment = 0;
        }
    },

    _getClientTime: function() {
        return Math.floor(+new Date() / 1000);
    },
    
    toClientTimestamp: function(serverTimestamp) {
        return serverTimestamp - this._adjustment;
    },
    
    getTimestamp: function() {
        return Math.round(this._adjustment + this._getClientTime());
    },

    adjust: function(serverTimestamp, clientTime) {
        this._adjustment = serverTimestamp - (clientTime || this._getClientTime());
    }

});
